export const loadBookPublishingQuestionnaireExperience = () =>
    import(
        /* webpackChunkName: 'book_publishing_questionnaire' */ '@fiverr-private/book_publishing_questionnaire'
    ).then((mod) => ({ default: mod.BookPublishingQuestionnaireExperience }));
